module.exports = __webpack_public_path__ + "static/media/profile.13a16178.svg";